import React from "react";
import {
  FormControl,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { map } from "ramda";

const useStyles = makeStyles((theme) => ({
  pickerSelect: {
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 30,
  },
}));

const ReportsPicker = ({
  selectedValue,
  values,
  pickerLabel,
  onSelectedChange,
}) => {
  const classes = useStyles();

  return (
    <Grid container direction="column">
      <FormControl className={classes.pickerSelect}>
        <Select
          label={pickerLabel || ""}
          value={selectedValue}
          onChange={(event) => onSelectedChange(event.target.value)}
        >
          {map(
            ({ id, name }) => (
              <MenuItem key={id} value={id}>
                <Typography nowrap="true">
                  {name}
                  <br />({id})
                </Typography>
              </MenuItem>
            ),
            values
          )}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default ReportsPicker;
